module.exports = __webpack_public_path__ + "img/dentalicon-2.24ee69d5.png";